/* eslint-disable react/jsx-no-comment-textnodes */
import type { ReactNode, ReactElement } from 'react';

// material
import { styled } from '@mui/material/styles';
import { TimelineDot } from '@mui/lab';

export interface MTimelineDotProps {
  color?: string;
  variant?: any;
  [key: string]: any;
}

// ----------------------------------------------------------------------

// @ts-ignore legacy boundary
const TimelineDotStyle = styled(TimelineDot)(({ theme, styleProps }) => {
  const { color, variant } = styleProps;

  return {
    ...(variant === 'filled'
      ? {
          '&.MuiTimelineDot-filled': {
            color: theme.palette[color].contrastText,
            backgroundColor: theme.palette[color].main,
          },
        }
      : {
          '&.MuiTimelineDot-outlined': {
            borderColor: theme.palette[color].main,
          },
        }),
  };
});

// ----------------------------------------------------------------------

export default function MTimelineDot({
  color = 'grey',
  variant = 'filled',
  ...other
}: MTimelineDotProps) {
  if (
    color === 'grey' ||
    color === 'inherit' ||
    color === 'primary' ||
    color === 'secondary'
  ) {
    return <TimelineDot color={color} variant={variant} {...other} />;
  }

  return (
    <TimelineDotStyle
      variant={variant}
      // @ts-ignore legacy boundary
      styleProps={{ color, variant }}
      {...other}
    />
  );
}
